<h2 mat-dialog-title>Employee Profile</h2>

<mat-dialog-content class="detail-dialog">
  @if (loading) {
    <div class="loading"><mat-spinner diameter="40"></mat-spinner></div>
  } @else if (error) {
    <p class="error">{{ error }}</p>
  } @else if (profile) {
    <div class="detail-header">
      <div class="detail-avatar">
        @if (photoUrl) {
          <img [src]="photoUrl" alt="Profile" />
        } @else {
          <span>{{ (profile.firstName?.[0] || '') + (profile.lastName?.[0] || '') }}</span>
        }
      </div>
      <div class="detail-names">
        <h3>{{ profile.firstName }} {{ profile.middleName }} {{ profile.lastName }}</h3>
        <p>{{ profile.jobTitle || '—' }} · {{ profile.departmentName || '—' }}</p>
        <span class="status-badge">{{ profile.statusLabel || profile.status }}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <h4>Personal</h4>
    <div class="detail-grid">
      <div class="detail-item"><span class="label">Employee ID</span><span class="value">{{ profile.employeeNumber }}</span></div>
      <div class="detail-item"><span class="label">Gender</span><span class="value">{{ profile.genderLabel }}</span></div>
      <div class="detail-item"><span class="label">Date of birth</span><span class="value">{{ profile.dateOfBirth || '—' }}</span></div>
      <div class="detail-item"><span class="label">Marital status</span><span class="value">{{ profile.maritalStatusLabel }}</span></div>
      <div class="detail-item"><span class="label">Blood group</span><span class="value">{{ profile.bloodGroupLabel }}</span></div>
      <div class="detail-item"><span class="label">CNIC / National ID</span><span class="value">{{ profile.nationalId || '—' }}</span></div>
      <div class="detail-item"><span class="label">Passport</span><span class="value">{{ profile.passportNumber || '—' }}</span></div>
      <div class="detail-item"><span class="label">Nationality</span><span class="value">{{ profile.nationality || '—' }}</span></div>
      <div class="detail-item"><span class="label">Religion</span><span class="value">{{ profile.religion || '—' }}</span></div>
      <div class="detail-item"><span class="label">Personal email</span><span class="value">{{ profile.personalEmail || '—' }}</span></div>
      <div class="detail-item"><span class="label">Company email</span><span class="value">{{ profile.companyEmail || '—' }}</span></div>
      <div class="detail-item"><span class="label">Mobile</span><span class="value">{{ profile.mobileNumber || '—' }}</span></div>
      <div class="detail-item"><span class="label">Alternate contact</span><span class="value">{{ profile.alternateContact || '—' }}</span></div>
      <div class="detail-item"><span class="label">Emergency contact</span><span class="value">{{ profile.emergencyContactName || '—' }} ({{ profile.emergencyContactRelation || '—' }}) {{ profile.emergencyContactPhone || '' }}</span></div>
    </div>

    <h4>Address</h4>
    <div class="detail-grid">
      <div class="detail-item"><span class="label">Current</span><span class="value">{{ profile.currentAddress || '—' }}</span></div>
      <div class="detail-item"><span class="label">Permanent</span><span class="value">{{ profile.permanentAddress || '—' }}</span></div>
      <div class="detail-item"><span class="label">City</span><span class="value">{{ profile.city || '—' }}</span></div>
      <div class="detail-item"><span class="label">Province</span><span class="value">{{ profile.province || '—' }}</span></div>
      <div class="detail-item"><span class="label">Country</span><span class="value">{{ profile.country || '—' }}</span></div>
      <div class="detail-item"><span class="label">Postal code</span><span class="value">{{ profile.postalCode || '—' }}</span></div>
    </div>

    <h4>Employment</h4>
    <div class="detail-grid">
      <div class="detail-item"><span class="label">Joining date</span><span class="value">{{ profile.hireDate || '—' }}</span></div>
      <div class="detail-item"><span class="label">Confirmation date</span><span class="value">{{ profile.confirmationDate || '—' }}</span></div>
      <div class="detail-item"><span class="label">Team</span><span class="value">{{ profile.teamName || '—' }}</span></div>
      <div class="detail-item"><span class="label">Reporting manager</span><span class="value">{{ profile.managerName || '—' }}</span></div>
      <div class="detail-item"><span class="label">Team lead</span><span class="value">{{ profile.teamLeadName || '—' }}</span></div>
      <div class="detail-item"><span class="label">Project manager</span><span class="value">{{ profile.projectManagerName || '—' }}</span></div>
      <div class="detail-item"><span class="label">HR manager</span><span class="value">{{ profile.hrManagerName || '—' }}</span></div>
      <div class="detail-item"><span class="label">Type</span><span class="value">{{ profile.employmentTypeLabel }}</span></div>
      <div class="detail-item"><span class="label">Shift</span><span class="value">{{ profile.shift || '—' }}</span></div>
      <div class="detail-item"><span class="label">Office location</span><span class="value">{{ profile.officeLocation || '—' }}</span></div>
    </div>

    @if (profile.canViewSalary && profile.salary) {
      <h4>Salary information</h4>
      <div class="detail-grid">
        <div class="detail-item"><span class="label">Salary type</span><span class="value">{{ profile.salary.salaryTypeLabel }}</span></div>
        <div class="detail-item"><span class="label">Hourly rate</span><span class="value">{{ profile.salary.hourlyRate ?? '—' }}</span></div>
        <div class="detail-item"><span class="label">Monthly salary</span><span class="value">{{ profile.salary.monthlySalary ?? '—' }}</span></div>
        <div class="detail-item"><span class="label">Overtime rate</span><span class="value">{{ profile.salary.overtimeRate ?? '—' }}</span></div>
        <div class="detail-item"><span class="label">Fuel allowance</span><span class="value">{{ profile.salary.fuelAllowance ?? '—' }}</span></div>
        <div class="detail-item"><span class="label">Medical allowance</span><span class="value">{{ profile.salary.medicalAllowance ?? '—' }}</span></div>
        <div class="detail-item"><span class="label">Other allowances</span><span class="value">{{ profile.salary.otherAllowances ?? '—' }}</span></div>
        <div class="detail-item"><span class="label">Tax number</span><span class="value">{{ profile.salary.taxNumber || '—' }}</span></div>
        <div class="detail-item"><span class="label">Bank</span><span class="value">{{ profile.salary.bankName || '—' }}</span></div>
        <div class="detail-item"><span class="label">Account</span><span class="value">{{ profile.salary.accountNumber || '—' }}</span></div>
        <div class="detail-item"><span class="label">IBAN</span><span class="value">{{ profile.salary.iban || '—' }}</span></div>
      </div>
    }

    <h4>Employment timeline</h4>
    @if (timelineLoading) {
      <mat-spinner diameter="28"></mat-spinner>
    } @else if (!timeline.length) {
      <p class="muted">No timeline events yet.</p>
    } @else {
      <div class="timeline">
        @for (ev of timeline; track ev.id) {
          <div class="timeline-item">
            <div class="timeline-dot"></div>
            <div class="timeline-body">
              <strong>{{ ev.title }}</strong>
              <span class="meta">{{ ev.eventTypeLabel }} · {{ ev.occurredAt | date:'medium' }}</span>
              @if (ev.description) { <p>{{ ev.description }}</p> }
            </div>
          </div>
        }
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
